export const recruitmentDataTransform = (rawData, t) => {
  const dataMap = rawData.reduce((acc, item) => {
    acc[item.label] = item.value || 0; // Ensure valid values
    return acc;
  }, {});

  const suitableCandidates = dataMap.Beworben - (dataMap["Automatisch abgesagt"] || 0);
  const value = Number.isNaN(suitableCandidates) ? 0 : suitableCandidates;

  const recruitmentSteps = [
    {
      id: 1,
      label: `${t ? t("Applied") : "Beworben"} - ${dataMap.Beworben || 0}`,
      value: dataMap.Beworben || 0,
      color: "rgb(30, 34, 255)"
    },
    {
      id: 2,
      label: `${t ? t("Suitable candidates") : "Geeignete Kandidaten"} - ${value}`,
      value,
      color: "rgb(171, 180, 244)"
    },
    {
      id: 3,
      label: `${t ? t("Forwarded applicants") : "Weitergeleitet an Fachabteilung"} - ${
        dataMap["Weitergeleitet an Fachabteilung"] || 0
      }`,
      value: dataMap["Weitergeleitet an Fachabteilung"] || 0,
      color: "rgb(250, 185, 0)"
    },
    {
      id: 4,
      label: `${t ? t("Interviewing") : "Zur Vorstellung"} - ${dataMap["Zur Vorstellung"] || 0}`,
      value: dataMap["Zur Vorstellung"] || 0,
      color: "rgb(78, 205, 196)"
    },
    {
      id: 5,
      label: `${t ? t("Hired") : "Eingestellt"} - ${dataMap.Eingestellt || 0}`,
      value: dataMap.Eingestellt || 0,
      color: "rgb(39, 221, 139)"
    }
  ];

  return recruitmentSteps.filter((step) =>
    step.id === 2 ? step.value !== recruitmentSteps[0].value : true
  );
};

export const translateCandidate = (t, count) => {
  if (!t) {
    return count === 1 ? "Kandidat" : "Kandidaten";
  }

  return count === 1 ? t("Candidate") : t("Candidates");
};
